// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Column numbers along the top and row letters down the left — the grid
// references operators use over the radio ("CRAH-2, column 7").

import React from 'react';
import type { FloorPlanLayout } from '../../../types/floorPlan';

// Negative: the labels sit in the margin the graphic's viewBox reserves around
// the plan, so they never collide with the shell.
const TOP_INSET = -5;
const LEFT_INSET = -7;

export default function PlanAxes({ axes }: { axes: FloorPlanLayout['axes'] }) {
  return (
    <g className="plan-axes" aria-hidden="true">
      {axes.top.map(t => (
        <text
          key={`t-${t.label}`}
          x={t.at}
          y={TOP_INSET}
          className="plan-axis-tick"
          textAnchor="middle"
        >
          {t.label}
        </text>
      ))}
      {axes.left.map(t => (
        <text
          key={`l-${t.label}`}
          x={LEFT_INSET}
          y={t.at}
          className="plan-axis-tick"
          textAnchor="middle"
        >
          {t.label}
        </text>
      ))}
    </g>
  );
}
